var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute right-0 w-56 origin-top-right outline-none",class:{ visible: _vm.isVisible, invisible: !_vm.isVisible }},[(!_vm.useShow)?[(_vm.isVisible)?[_vm._t("default")]:_vm._e()]:[[_vm._t("default")]]],2)}
var staticRenderFns = []

export { render, staticRenderFns }